import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import ProfileCard from "../components/ProfileCard";

export default function Favorites() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/favorites").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (profileId) => {
    await api.delete(`/favorites/${profileId}`);
    setItems((it) => it.filter((p) => p.id !== profileId));
  };

  return (
    <div className="space-y-5 animate-fade-in-up">
      <div className="flex items-center gap-2">
        <button onClick={() => navigate(-1)} className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-slate-100" data-testid="fav-back-btn">
          <i className="fa-solid fa-arrow-left"></i>
        </button>
        <h1 className="text-2xl md:text-3xl font-extrabold">Mis favoritos</h1>
      </div>

      {loading ? (
        <div className="text-center py-16 text-slate-500">Cargando…</div>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-slate-500" data-testid="favorites-empty">
          <i className="fa-regular fa-heart text-5xl text-slate-300"></i>
          <p className="mt-4 font-bold text-slate-700">Sin favoritos aún</p>
          <p className="text-sm">Toca el corazón en los perfiles que te gusten para guardarlos aquí</p>
          <Link to="/home" className="btn-primary mt-6 inline-flex" data-testid="fav-explore-btn">Explorar perfiles</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((p) => (
            <ProfileCard key={p.id} profile={p} accent={p.type === "profesor" ? "teal" : "blue"} isFavorite={true} onToggleFavorite={() => remove(p.id)} />
          ))}
        </div>
      )}
    </div>
  );
}
